
































import { defineComponent, nextTick, onMounted, PropType, ref } from '@nuxtjs/composition-api'
import { useEventListener } from '@vueuse/core'
import GCarousel from '@/components/GCarousel.vue'
// @ts-ignore
import Slide from 'vue-carousel/src/Slide.vue'

export default defineComponent({
  components: {
    GCarousel,
    Slide,
  },
  props: {
    list: {
      type: Array as PropType<Array<string>>,
      default: () => [],
    },
    twoRows: {
      type: Boolean,
      default: false,
    },
    imgClass: {
      type: String,
      default: 'h-40',
    },
    acceptForeigner: {
      type: Boolean,
      default: false,
    },
    /** 目前先以多張照片共用alt */
    imgAlt: {
      type: String,
      default: '',
    },
  },
  setup (props, { emit }) {
    const carousel = ref<Vue | null>(null)

    const clickPrevious = (e: Event) => {
      e.stopPropagation()
      emit('prev')
    }
    const clickNext = (e: Event) => {
      e.stopPropagation()
      emit('next')
    }

    onMounted(async () => {
      await nextTick()
      const el = carousel.value?.$el
      const previous = el?.querySelector('.VueCarousel-navigation-prev')
      const next = el?.querySelector('.VueCarousel-navigation-next')

      useEventListener(previous, 'click', clickPrevious)
      useEventListener(next, 'click', clickNext)
    })

    // Image List => 決定最終渲染的圖片
    const imgList = ref<Array<string>>([])
    onMounted(async () => {
      await nextTick()
      imgList.value = props.list.map(src => getGenImageSrc(src))
    })

    const getGenImageSrc = (src: string) => {
      const splitted = src.split('.')
      if (splitted.length < 2) return src
      splitted[splitted.length - 2] = `${splitted[splitted.length - 2]}_gen`
      return splitted.join('.')
    }

    const onImageError = (_event: ErrorEvent, index: number) => {
      const _list = imgList.value
      _list[index] = props.list[index]
      imgList.value = [..._list]
    }

    return {
      imgList,
      carousel,

      getGenImageSrc,
      onImageError,
    }
  },
})
